import { Container } from '../../../odie';

import { AnimalBlockProps } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';

// constants
//-----------------------------------------------------------------------------
const manifest = {
  image: 'animal/block.animal.png',
};

/*
    animal block view
*/
export class AnimalBlockView extends Container {
  // init
  //-------------------------------------------------------------------------
  constructor(props: AnimalBlockProps) {
    // spawn
    super();
    this.addChild(new FitWidthBlockSprite(manifest.image, props));

    // position
    blockPositionView(this, props);
  }

  public static assets(): string[] {
    return [manifest.image];
  }
}
